import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

export const useAssistanceCatalog = () => {
  const [catalog, setCatalog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const controller = useRef(null);
  const reload = useCallback(async () => {
    controller.current?.abort();
    const current = new AbortController();
    controller.current = current;
    setLoading(true); setError('');
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/quote-catalog`, { signal: current.signal, timeout: 15000 });
      if (!Array.isArray(data.groups) || !data.groups.length || !data.groups.every(group => Array.isArray(group.sections) && group.sections.every(section => Array.isArray(section.items)))) throw new Error('Invalid catalog');
      if (!current.signal.aborted) setCatalog(data);
    } catch (cause) {
      if (!current.signal.aborted && !axios.isCancel(cause)) setError('No pudimos cargar las asistencias. Puedes intentarlo de nuevo o solicitar tu asesoría.');
    } finally {
      if (!current.signal.aborted) setLoading(false);
    }
  }, []);
  useEffect(() => {
    try { sessionStorage.removeItem('sabeteam-quote-draft'); } catch { /* Catalog browsing never requires storage. */ }
    reload();
    return () => controller.current?.abort();
  }, [reload]);
  return { catalog, loading, error, reload };
};